var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.844 10.7064C3.40791 11.8468 4.32271 12.7764 5.454 13.3584C6.577 13.9353 7.85759 14.1301 9.10133 13.9131C10.3489 13.6935 11.4918 13.0761 12.3593 12.1531C13.2346 11.2211 13.792 10.0357 13.9513 8.76707C14.1128 7.49557 13.8693 6.20551 13.2553 5.08041C12.647 3.96387 11.696 3.07229 10.5427 2.53707C9.39713 2.00652 8.10976 1.8642 6.876 2.13174C5.64267 2.39907 4.632 3.00707 3.796 3.96841C3.69533 4.07507 3.306 4.50574 2.98267 5.15574M5 5.33307L2.594 5.81307L2 3.33307M8 5.99974V8.66641L10 9.99974",
    stroke: "#00B9F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f9487f4c00bea7907e3934403696f270.svg";
export { ForwardRef as ReactComponent };